import { render } from "./StatistichePDC.vue?vue&type=template&id=8749b626&scoped=true"
import script from "./StatistichePDC.vue?vue&type=script&lang=js"
export * from "./StatistichePDC.vue?vue&type=script&lang=js"

import "./StatistichePDC.vue?vue&type=style&index=0&id=8749b626&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8749b626"]])

export default __exports__